import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './DeleteIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const DeleteIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function DeleteIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 20 22" component={Icon} {...props} />
  );
});
